import { Api } from '../../api';

import { errorToast, useOutsideClick, successToast } from '../../utils/helper';
import { PencilSquareIcon, TrashIcon, ArrowUturnLeftIcon } from '@heroicons/react/24/outline';
import CommonPopover from '../../component/common/popover';
import Table from '../../component/common/Table';
import React from 'react';
import { useRef, useState, useEffect } from 'react';
import { Calendar } from 'react-date-range';
import SearchInput from '../../component/common/Input/SearchInput';
import { Helmet } from 'react-helmet';
import UpgradeDownArrow from '../../assets/images/upgrade-down-arrow.svg';
import { PER_PAGE, TEST_FEATURE_STATUS } from '../../utils/constants';
import { ChevronDownIcon, ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import Loader from '../../component/common/Loader';
import Topbar2 from '../PulseSurvey/Topbar';
import Pagination from '../../component/common/Pagination/Pagination';
import { ShoorahTestDashboardPageData } from '../../utils/pageContent';

function ViewTests({topbarShow = true}) {
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const statusDropdownRef = useRef(null);
  const calendarRef = useRef(null);
  const [isOpen2, setIsOpen2] = useState(false);
  const [startDate, setStartDate] = useState();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [testStatusType, settestStatusType] = useState(TEST_FEATURE_STATUS.PUBLISH);
  const status = Object.entries(TEST_FEATURE_STATUS).filter((item) => item[1] !== 9);

  const [IsTestStatusOpen, setIsTestStatusOpen] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [sortBy, setSortBy] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [categoriesList, setCategoriesList] = useState('');
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const pageData = ShoorahTestDashboardPageData;

  const redirectUrl = '/marketplace/create-new-company-offer?page=createcompany';
  const columns = [
    {
      title: '',
      key: 'profile',
      sortable: false,
      type: 'profile-without-name-2',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.testTitle,
      key: 'name',
      sortable: false,
      type: 'text',
      align: 'left',
      width: 100,
      rowClassName: '!text-base font-medium'
    },
    {
      title: pageData.tableHeaderText.testGroup,
      key: 'group_name',
      sortable: false,
      type: 'text',
      align: 'center'
    },
    {
      title: pageData.tableHeaderText.createdBy,
      key: 'created_by',
      sortable: false,
      type: 'text',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.createdDate,
      key: 'status',
      sortable: false,
      type: 'date',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.status,
      key: 'status',
      sortable: false,
      type: 'text',
      align: 'left'
    }
  ];

  // Function to fetch test data with pagination
  // Function to fetch test data with pagination
  const handlePagination = (
    pageNumber,
    pageSize,
    sortByKey,
    orderByKey,
    statusCode,
    searchKey,
    date = '',
    categories = ''
  ) => {
    setLoader(true);

    if (sortByKey === '') sortByKey = 'createdAt';
    if (orderByKey === '') orderByKey = 'desc';

    Api.getAllTests(
      pageNumber,
      pageSize,
      sortByKey,
      orderByKey,
      statusCode,
      searchKey,
      date || startDate || '',
      categories || categoriesList || ''
    )
      .then((response) => {
        setLoader(false);

        if (response?.data?.data) {
          setUsersList(
            response?.data?.data?.data?.map(({ cover_image, title, ...rest }) => ({
              ...rest,
              profile: cover_image !== null ? cover_image : null,
              name: String(title ?? '')
            }))
          );

          setCurrentPage(pageNumber);
          setTotalCount(response?.data?.data?.pagination?.totalCount);
          setCurrentPage(pageNumber);
          setTotalCount(response?.data?.data?.pagination?.totalCount);
        } else if (response?.data?.meta?.code === 401) {
          errorToast(response?.message);
        } else if (response?.data?.meta?.code === 0) {
          setCurrentPage(1);
          setUsersList([]);
          setTotalCount(0);
          errorToast(response?.data?.meta?.message);
        }
      })
      .catch((error) => {
        errorToast(pageData.failedToFetchTestErrorMessage);
        setLoader(false);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    // Check URL for initial filter values
    const params = new URLSearchParams(window.location.search);
    const statusParam = params.get('status');
    const categoriesParam = params.get('categories');

    // Apply URL parameters if present
    if (statusParam && !isNaN(parseInt(statusParam))) {
      settestStatusType(parseInt(statusParam));
    }

    if (categoriesParam) {
      setCategoriesList(categoriesParam);
    }

    // Initial data fetch - passing the detected URL params
    handlePagination(
      1,
      selectedPerPage?.value,
      sortBy,
      sortOrder,
      statusParam ? parseInt(statusParam) : testStatusType,
      searchTerm,
      params.get('createdAt') || '',
      categoriesParam || ''
    );

    return () => {
      if (debounceTimeout) clearTimeout(debounceTimeout);
    };
  }, []);

  const refreshTable = () =>
    handlePagination(
      1,
      selectedPerPage?.value,
      sortBy,
      sortOrder,
      testStatusType,
      '', // Reset search term
      startDate,
      categoriesList
    );

  const handleChangeC = (e) => {
    const date = new Date(e);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setStartDate(formattedDate);

    // Update to pass date to the API call

    // Update to pass date to the API call
    handlePagination(
      1,
      selectedPerPage.value,
      sortBy,
      sortOrder,
      testStatusType,
      searchTerm,
      formattedDate,
      categoriesList
    );

    setIsOpen2(false);
  };

  const handleChangeInStatus = (option) => {
    settestStatusType(option);
    handlePagination(1, selectedPerPage.value, sortBy, sortOrder, option, searchTerm);
    setIsTestStatusOpen(false);
  };

  // useRef to handle click outside the Date range calendar
  // useRef to handle click outside the Date range calendar
  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  useOutsideClick(statusDropdownRef, () => {
    setIsTestStatusOpen(false);
  });

  const deleteHandler = (_id) => {
    setLoader(true);
    setSearchTerm('');

    Api.delTest(_id).then((response) => {
      if (response?.data?.meta?.code === 1) {
        handlePagination(1, selectedPerPage?.value, sortBy, sortOrder, testStatusType, '');
        successToast(pageData.testDeleteSuccessMessage);
      } else if (response?.data?.meta?.code === 0) {
        setLoader(false);
        errorToast(response?.data?.meta?.message ?? pageData.testDeleteErrorMessage);
      } else if (response?.code === 500) {
        setLoader(false);
        errorToast(response?.data?.meta?.message ?? pageData.testDeleteErrorMessage);
      } else {
        setLoader(false);
      }
    });
  };

  const restoreHandler = (_id) => {
    setLoader(true);
    setSearchTerm('');

    // Use the same API pattern as CreateTest.js for updating test status
    const payloadForRestore = {
      status: 3 // Change status to approved (3) to restore the test
    };

    Api.putUpdateTest(_id, payloadForRestore)
      .then((response) => {
        if (response?.data?.meta?.code === 1) {
          handlePagination(1, selectedPerPage?.value, sortBy, sortOrder, testStatusType, '');
          successToast(pageData.testRestoreSuccessMessage);
        } else if (response?.data?.meta?.code === 0) {
          setLoader(false);
          errorToast(response?.data?.meta?.message ?? pageData.testRestoreErrorMessage);
        } else if (response?.code === 500) {
          setLoader(false);
          errorToast(response?.data?.meta?.message ?? pageData.testRestoreErrorMessage);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log('Error while making the putUpdateTest API call for restore', error);
        errorToast(pageData.failedToRestoreTestMessage);
        setLoader(false);
      });
  };

  const rowsData = usersList.map((item) => {
    return {
      ...item,
      name: (
        <>
          <div>
            {item.name
              ? item.name
                  .split(' ')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' ')
              : ''}
          </div>
        </>
      ),
      group_name: <>{item.group_id?.title ?? 'NA'}</>,
      created_by: <>{item.created_by?.name ?? 'NA'}</>,
      test_created_by: <>{item.test_created_by?.name}</>,
      test_reviewed_by: <>{item.test_reviewed_by?.name}</>,
      test_approved_by: <>{item.test_approved_by?.name}</>,
      status: (
        <>
          <div className="flex items-center justify-center">
            <div
              className={`w-28 h-7 flex items-center justify-center text-center text-xs rounded-full border appearance-none mx-2
    ${
      item?.status === 2
        ? 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261]' // REJECTED
        : item?.status === 3 || item?.status === 4
        ? 'bg-[#DDF2BF] text-[#438038] border-[#438038]' // APPROVED or PUBLISHED
        : item?.status === 5
        ? 'bg-[#FFE4E1] text-[#8B0000] border-[#8B0000]' // DELETED - different styling
        : 'bg-white text-black border-black' // DRAFT, SENT_FOR_APPROVAL, INACTIVE
    }`}
            >
              {item?.status === 0
                ? pageData.statusOptions.draft
                : item?.status === 1
                ? pageData.statusOptions.pending
                : item?.status === 2
                ? pageData.statusOptions.rejected
                : item?.status === 3
                ? pageData.statusOptions.approved
                : item?.status === 4
                ? pageData.statusOptions.published
                : item?.status === 5
                ? pageData.statusOptions.deleted
                : pageData.statusOptions.unknown}
            </div>
            <div className="flex items-center ml-3">
              {/* Conditional rendering based on status */}
              {item?.status === 5 ? (
                // Show only restore icon for deleted tests (NO EDIT ICON)
                <>
                  {/* Restore Icon */}
                  <ArrowUturnLeftIcon
                    className="w-[20px] ml-2 text-shoorah-secondary dark:text-white cursor-pointer"
                    onClick={() => restoreHandler(item?._id)}
                  />
                </>
              ) : (
                // Show normal edit and delete icons for non-deleted tests
                <>
                  <PencilSquareIcon
                    className="w-[20px] ml-2 text-shoorah-secondary dark:text-white cursor-pointer"
                    onClick={() => {
                      navigate(`/test/tests-dashboard/create-test?testid=${item?._id}`);
                    }}
                  />
                  <TrashIcon
                    className="w-[20px] ml-2 text-red-500 cursor-pointer"
                    onClick={() => deleteHandler(item?._id)}
                  />
                </>
              )}
            </div>
          </div>
        </>
      )
    };
  });

  return (
    <>
      <div className="relative lg:ps-5 lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{pageData.metaTitle}</title>
          <title>{pageData.metaTitle}</title>
        </Helmet>
        {loader ? <Loader /> : null}
        {topbarShow === true &&
        <Topbar2 title={pageData.pageTitle} infoBtn={true} />}
      </div>

      <div className="relative lg:pl-5 lg:mb-[45px]">
        {/*search options, Date filter & Add Company are here */}
        <div className="sm:flex flex-col md:flex-row justify-between items-center gap-3">
          {/* Left-aligned search input */}
          {/* Left-aligned search input */}
          <div className="flex items-center justify-center w-full sm:w-auto">
            <SearchInput
              id="searchKey"
              name="searchKey"
              type="text"
              onChange={(e) => {
                setSearchTerm(e.target.value);
                // Debouncing search input
                if (debounceTimeout) clearTimeout(debounceTimeout);
                const timeout = setTimeout(() => {
                  handlePagination(
                    1,
                    selectedPerPage?.value,
                    sortBy,
                    sortOrder,
                    testStatusType,
                    e.target.value,
                    startDate,
                    categoriesList
                  );
                }, 500);
                setDebounceTimeout(timeout);
              }}
              placeholder={pageData.searchPlaceholder}
              className="w-full sm:w-auto px-3 py-2"
            />
          </div>

          {/* Right-aligned buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
            <div ref={ref3} className="relative inline-block text-left w-64 sm:w-auto">
              {/* Test status Filter */}
              <button
                type="button"
                onClick={() => setIsTestStatusOpen(!IsTestStatusOpen)}
                className="inline-flex justify-between items-center w-full gap-2 px-4 py-[9px] sm:text-sm text-[12px] font-medium border dark:border-text-shoorah-darkBg border-shoorah-lightBlack sm:rounded-[100px] rounded-[80px] dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
              >
                <span className="capitalize">
                  {Object.entries(TEST_FEATURE_STATUS)
                    .find((item) => item[1] === testStatusType)[0]
                    .replace(/_/g, ' ')}
                </span>
                <ChevronDownIcon className="w-5 h-5" />
              </button>
              {IsTestStatusOpen && (
                <div
                  className="absolute left-[-12px] z-10 mt-1 w-[180px] bg-white divide-y divide-gray-100 rounded-md ring-1 ring-[#E7EAE8] ring-opacity-1 dark:bg-shoorah-darkBgColor dark:border-none dark:ring-opacity-0"
                  ref={statusDropdownRef}
                >
                  <ul className="py-1 text-sm text-gray-700 dark:text-shoorah-darkBg">
                    {status.map(([key, val]) => {
                      return (
                        <li key={val}>
                          <button
                            onClick={() => {
                              handleChangeInStatus(val);
                            }}
                            className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:text-shoorah-darkBg dark:hover:text-shoorah-darkBgColor"
                          >
                            {key.replace(/_/g, ' ')}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
              {/* Test status Filter */}
            </div>

            <div ref={ref2} className="relative inline-block text-left w-64 sm:w-auto">
              <button
                type="button"
                onClick={() => setIsOpen2(!isOpen2)}
                className="flex justify-between items-center w-full sm:w-auto px-5 py-2 text-xs sm:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
              >
                <span>
                  {startDate ? `${new Date(startDate).toLocaleDateString()}` : pageData.dateCreatedText}
                </span>
                {selectedTheme ? (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#F3F4F6"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </>
                ) : (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#0B1D2E"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </>
                )}
              </button>
              {isOpen2 && (
                <div
                  className="absolute sm:-top-2 top-0 md:-left-60 sm:-left-40 left-0 w-full sm:w-auto transform scale-90 sm:scale-100 z-10 mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                  ref={calendarRef}
                >
                  <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                    <Calendar
                      className={'calendar text-sm sm:text-lg'}
                      onChange={handleChangeC}
                      nextLabel={
                        <button className="custom-next-button flex justify-center items-center">
                          <ChevronRightIcon className="w-8 h-8" />
                        </button>
                      }
                      maxDate={new Date()}
                      prevLabel={
                        <button className="custom-prev-button flex justify-center items-center">
                          <ChevronLeftIcon className="w-8 h-8" />
                        </button>
                      }
                      date={startDate ? new Date(startDate) : new Date()}
                      navigationLabel={({ date }) => (
                        <button
                          style={{ cursor: 'default', pointerEvents: 'none' }}
                          className="text-base"
                        >
                          {date.toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long'
                          })}
                        </button>
                      )}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="self-center inline-flex items-center justify-center w-64 sm:w-auto">
              <button
                className="inline-flex text-xs sm:text-base font-medium items-center justify-center rounded-3xl border bg-shoorah-secondary px-5 py-2 text-white shadow-sm hover:shoorah-primary focus:outline-none w-full sm:w-auto"
                onClick={() => {
                  navigate('/test/tests-dashboard/create-test');
                }}
              >
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.5 4.45825V15.5416"
                    stroke="white"
                    stroke-width="1.58333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.95801 10H15.0413"
                    stroke="white"
                    stroke-width="1.58333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {pageData.addTextBtnText}
              </button>
            </div>
          </div>
        </div>

        <div className="lg:mt-8 flex flex-col">
          <div className="mt-4 w-full md:w-[100%]">
            <Table
              columns={columns}
              data={rowsData}
              addNewURL={redirectUrl}
              name={'company_table'}
              setDeleteId={deleteHandler}
              bottomBorder={totalCount > selectedPerPage?.value}
              refreshTable={refreshTable}
              loader={loader}
            />
          </div>
        </div>

        <div>
          {usersList.length > 0 && !loader ? (
            <Pagination
              currentPage={currentPage}
              totalCount={totalCount}
              pageSize={selectedPerPage?.value}
              onPageChange={(page) => {
                handlePagination(
                  page,
                  selectedPerPage?.value,
                  sortBy,
                  sortOrder,
                  testStatusType,
                  searchTerm
                );
              }}
            />
          ) : (
            <span />
          )}
        </div>
      </div>
    </>
  );
}

export default ViewTests;